module.exports = __webpack_public_path__ + "static/img/rest61.cd7b4be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rest61.jpg
// module id = yYGq
// module chunks = 0